/**
 * Utility functions for handling Linear tickets
 */

interface Commit {
  message?: string;
  full_message?: string;
  author?: string;
  date?: string;
  sha?: string;
  url?: string;
  formatted_message?: string;
}

export const extractTicketNumbers = (message: string): string[] => {
  const pattern = /\b(ENG-\d+)\b/gi;
  return message.match(pattern) || [];
};

export const hasTicketNumbers = (commit: Commit): boolean => {
  const fullMessage = commit.full_message || commit.message || '';
  return extractTicketNumbers(fullMessage).length > 0;
};

export const getAllTickets = (commits: Commit[]): string[] => {
  const allTickets = new Set<string>();
  
  commits.forEach(commit => {
    const fullMessage = commit.full_message || commit.message || '';
    const tickets = extractTicketNumbers(fullMessage);
    tickets.forEach(ticket => allTickets.add(ticket.toUpperCase()));
  });

  return Array.from(allTickets).sort();
};

export const filterCommits = (
  commits: Commit[],
  searchTerm: string = '',
  ticketFilter: string = ''
): Commit[] => {
  let filtered = [...commits];

  // Apply search term filter
  if (searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    filtered = filtered.filter(commit => {
      const message = commit.message || '';
      const fullMessage = commit.full_message || '';
      const author = (commit as any).author || '';
      
      return (
        message.toLowerCase().includes(searchLower) ||
        fullMessage.toLowerCase().includes(searchLower) ||
        author.toLowerCase().includes(searchLower)
      );
    });
  }

  // Apply ticket filter
  if (ticketFilter && ticketFilter !== 'All Tickets') {
    filtered = filtered.filter(commit => {
      const fullMessage = commit.full_message || commit.message || '';
      const tickets = extractTicketNumbers(fullMessage);
      return tickets.some(ticket => ticket.toUpperCase() === ticketFilter.toUpperCase());
    });
  }

  return filtered;
};
